var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: 0.5,
    width: 34,
    height: 34,
    rx: 17,
    transform: "matrix(-1 0 0 1 34 0)",
    stroke: "#222222"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1139 24.9915C20.2035 24.9912 20.2912 24.9653 20.3665 24.9167C20.4418 24.8682 20.5014 24.7991 20.5386 24.7177C20.5758 24.6362 20.5888 24.5457 20.5761 24.457C20.5634 24.3684 20.5255 24.2852 20.4669 24.2174L15.7759 18.8254C15.7642 18.8109 15.7512 18.7974 15.737 18.7854C15.4681 18.4544 15.332 18.0353 15.355 17.6094C15.3301 17.1413 15.4745 16.6798 15.762 16.3094L15.7799 16.2894L20.471 10.7634C20.5448 10.6682 20.579 10.5481 20.5666 10.4282C20.5541 10.3083 20.4959 10.1978 20.404 10.1198C20.312 10.0418 20.1935 10.0023 20.0731 10.0095C19.9528 10.0167 19.8399 10.0701 19.758 10.1584L15.074 15.6754C14.9358 15.8335 14.8201 16.0098 14.73 16.1994C14.5155 16.6439 14.4095 17.133 14.4209 17.6264C14.3966 18.2996 14.6351 18.9559 15.086 19.4564L19.7639 24.8344C19.8078 24.8839 19.8618 24.9234 19.9221 24.9505C19.9825 24.9776 20.0478 24.9916 20.1139 24.9915Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/left.45224d615ca202d9c81c53d410fb7a60.svg";
export { ForwardRef as ReactComponent };